import React from 'react';

// eslint-disable-next-line import/no-cycle
import { NavItem } from './NavItem';
import { NavItemType } from '../../../utils/navigationUtils';

interface NavProps {
  items: NavItemType[];
  openedTree: string;
  pathname: string;
  setOpenedTree: (tree: string) => void;
}

export const NavigationList: React.FC<NavProps> = ({ items, openedTree, pathname, setOpenedTree }) => (
  <ul className="navigation__list">
    {items.map((item) => (
      <NavItem item={item} key={item.url} openedTree={openedTree} pathname={pathname} onClick={setOpenedTree} />
    ))}
  </ul>
);
